export default __webpack_public_path__ + "static/media/Capture.9ebfb288.JPG";